import {CheckUtils, FileVoData} from "od-ts";
import {FileData, FileUtils} from "ui-ts";

export class FilesConverter {

  static convertToFilesVoData(files: Array<FileData>): Array<File> {
    let result: Array<File> = [];

    if (!CheckUtils.isEmpty(files)) {
      files.forEach(file => result.push(this.convertToFileVoData(file)));
    }
    return result;
  }

  static convertToFileVoData(file: FileData): File {
    let result: File = null;
    if (!CheckUtils.isEmpty(file)) {
      result = FilesConverter.convertFromSourceToFile(file.name, file.data);
    }
    return result;
  }

  static convertFromSourceToFile(name: string, source: string): File {

    let arr = source.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let file: File = null;
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      file = FilesConverter.blobToFile(new Blob([u8arr], {type: mime}), name);
    } else {
      file = new File([u8arr], name, {type: mime});
    }

    return file;
  }

  static blobToFile(theBlob: Blob, fileName: string): File {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return b as File;
  }

  static convertToFilesData(files: Array<FileVoData>): FileData[] {
    let result: FileData[] = [];
    if (!CheckUtils.isEmpty(files)) {
      files.forEach(file => {
        result.push(FilesConverter.convertToFileData(file));
      });
    }
    return result;
  }

  static convertToFileData(file: FileVoData): FileData {
    let fileData: FileData = new FileData();
    fileData.identityKey = file.uid;
    fileData.name = file.name;
    fileData.icon = FileUtils.getFileIcon(file.name);
    return fileData;
  }
}



// WEBPACK FOOTER //
// ./src/utils/converter/files-converter.ts